import React from 'react'
import { Select, MenuItem, InputLabel } from '@mui/material'
import { CHAMBERS, FEDERAL_CHAMBERS, STATE_CHAMBERS } from 'utils'

export interface Chamber {
  id: number
  code: string
  desc: string
}

export const ChamberSelect: React.FC<{
  value: Chamber | null
  updateChamber: (chamber: Chamber | null) => void
  disabled: boolean
  onlyFederal?: boolean
  onlyState?: boolean
}> = ({ value, updateChamber, disabled, onlyFederal = false, onlyState = false }) => {
  const handleChange = (value: string | number): void => {
    const selectedOption = Object.values(CHAMBERS).find(chamber => chamber.id === value)
    updateChamber(selectedOption ?? null)
  }

  const chambers = onlyFederal
    ? FEDERAL_CHAMBERS
    : onlyState
      ? STATE_CHAMBERS
      : Object.values(CHAMBERS)

  return (
    <React.Fragment>
      <InputLabel>Chamber</InputLabel>
      <Select
        label="Chamber"
        value={value?.id ?? ''}
        onChange={(event) => { handleChange(event.target.value) }}
        disabled={disabled}
        fullWidth
      >
        <MenuItem value="">
          None
        </MenuItem>
        {chambers.map(option => (
          <MenuItem key={option.id} value={option.id}>
            {option.desc}
          </MenuItem>
        ))}
      </Select>
    </React.Fragment>
  )
}
